import { Text } from '@mantine/core'
import ReportWrapper from '../ReportWrapper'
import LabeledContainer from '../../../components/LabeledContainer'
import React from 'react'

export default function ReportFooter() {
  return (
    <ReportWrapper>
      <LabeledContainer title={'报告说明'} />
      <Text c={'gray'} size={'sm'}>
        &nbsp;&nbsp;&nbsp;&nbsp;本报告的数据由用户本人明确授权后，向相关合法机构调取获得，仅向用户个人展示参考。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<b>同一用户七天内查询报告不得超过两次。</b>报告有效期为<b>30</b>天，过期自动删除。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;若您的数据不全面，可能是数据具有延迟性或者合作信息机构未获取到您的数据。
        <b>若数据有错误请联系客服</b>。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <b>任何诱导信息修复获取非法利益的行为都是欺诈！如对报告内容有异议，请联系客服。我司不接受任何信息修复业务。</b>
      </Text>
    </ReportWrapper>
  )
}
